<template>
  <div class="roll-number" v-html="html">
    0
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    num: {
      type: Number,
      default: 0
    }
  },
  watch: {
    num (val, old) {
      this.init(val)
    }
  },
  data() {
    return {
      html: ''
    };
  },
  mounted() {
    this.init(this.num, 2)
  },
  methods: {
    init (num) {
      let str = num + ''
      let len = str.length
      let i = 0

      let html = ''
      while (i < len) {
        html += `<p class="list-number trans${str[i] == 0 ? 2 : 1}" data-num="${str[i]}">
          <span>0</span> <span>1</span> <span>2</span> <span>3</span> <span>4</span>
          <span>5</span> <span>6</span> <span>7</span> <span>8</span> <span>9</span>
        </p>`
        i++
      }

      this.html = html

      this.$nextTick(() => {
        let domList = document.querySelectorAll('.list-number')
        setTimeout(() => {
          domList.forEach(item => {
            let numTemp = item.dataset.num * 22
            if (numTemp) {
              let radom = (Math.random() * 1 + 1)
              item.style = `transform: translate3d(0, -${numTemp}px, 0);transition-duration:${radom + 0.5}s`
              // item.style = `top: -${numTemp}px;transition-duration:${radom + 0.5}s`
            } else {
              let radom = (Math.random() * 1 + 1)
              item.style = `transform: translate3d(0, 0, 0);transition-duration:${radom + 0.5}s`
              // item.style = `top: 0;transition-duration:${radom + 0.5}s`
            }
          })
        }, 500)
      })
    }
  }
};
</script>

<style lang="scss">
.roll-number {
  // color: #fff;
  height: 22px;
  overflow: hidden;
  // border: 1px solid blue;
  .list-number {
    display: inline-block;
    transition-duration: 2s;
    transition-timing-function: ease-out;
    position: relative;
    span {
      display: block;
      line-height: 22px;
      height: 22px;
    }
  }
  .trans1 {
    transform: translate3d(0, 0, 0);
    // top: 0px;
  }
  .trans2 {
    transform: translate3d(0, -198px, 0);
    // top: -198px
  }
}
</style>
